import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import * as VueGoogleMaps from "gmap-vue";
import pjson from "../package.json";
import VueAwesomeSwiper from "vue-awesome-swiper";
import lineClamp from "vue-line-clamp";
import "swiper/css/swiper.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import IdleVue from "idle-vue";

const idleTime = 3600000;

library.add(faCcAmex, faCcDiscover, faCcMastercard, faCcVisa);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(lineClamp, { importCss: true });
Vue.use(VueAwesomeSwiper, {
  centeredSlides: true,
  centeredSlidesBounds: true,
  direction: "horizontal",
  freeMode: true,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: "places",
  },
});

Vue.use(IdleVue, { idleTime, store });

Vue.config.productionTip = false;

console.log(`v${pjson.version}`);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
